import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('common/nextButton')

class NextButtonComponent extends React.Component {
	render () {
		let buttonnext = messages.button && messages.button.next

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 text-center">
				<a href="#"
					style={{ maxWidth: 350, marginTop: 10, marginBottom: 10, fontSize: 15 }}
					className="vx_btn vx_btn-block"
					id="payWithPP"
					onClick={this.props.handleNext}>
					{buttonnext}
				</a>
			</div>
		);
	}
}

NextButtonComponent.propTypes = {
	label: PropTypes.string,
	handleNext: PropTypes.func,
};

export default NextButtonComponent



// WEBPACK FOOTER //
// ./components/nextButton.js